// extracted by mini-css-extract-plugin
export var phone = "_4y-0";
export var phoneDragging = "_4y-1";